import { render, staticRenderFns } from "./HeaderBase.vue?vue&type=template&id=2f177596&scoped=true&"
import script from "./HeaderBase.vue?vue&type=script&lang=js&"
export * from "./HeaderBase.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBase.vue?vue&type=style&index=0&id=2f177596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f177596",
  null
  
)

export default component.exports